import { RouteConfig } from 'vue-router'

import {
  PieceworkIndex,
  GeneratePieceworkForm
} from '@/views'

const pieceworkRouter: Array<RouteConfig> = [
	{
    path: '/piecework',
    name: 'piecework',
    component: PieceworkIndex,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Destajo Grupal'
    }
  },
  {
    path: '/piecework-form/:id?',
    name: 'piecework-form',
    component: GeneratePieceworkForm,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Ver/Generar Destajo Grupal'
    }
  }
]

export default pieceworkRouter
